module.exports = __webpack_public_path__ + "img/production.ff15a1a0.png";